export default {
  card_select_para: "Nice pick! They’ll love it! 🌸🙌",
  card_select_required: "Please select a card",
  delivery_window_select_required: "Please select a delivery window",
  card_msg_missing_first_name: "Recipient first name is missing",
  loved_by_canadians: "Loved by 100k+ Canadians",
  card_free_price: "Free",
  delivering: "Delivering in",
  in: "in",
  on: "on",
  change: "Change",
  qv_full_details: "View full details",
  qv_btn_text: "Add to basket",
  same_address_delivery: "Delivering to the same address?",
  complete_bouquet: "Make your gift extra special",
  complete_gift_set: "Complete your gift set",
  recipient_details: "Send to",
  delivery_window: "Delivery window",
  card_message: "Card & message",
  province_select: "Where is the wedding?",
  province_select_name: "Province",
  city_select: "Where is the wedding?",
  city_select_name: "City",
  subs_frequency: "Pick delivery dates",
  ongoing_frequency: "Pick a delivery date and frequency",
  wedding_product_select: "Florals & More: Easy, simple, and affordable.",
  wedding_product_select_name: "Florals",
  additional_dates_cart_label: "Additional delivery dates",
  submission_message: "",
  submission_message_name: "Done",
  greets: "Greets",
  vases: "Vases",
  hand_craft: "Hand-crafted gifts by local makers",
  greet_header:
    "Personalize your moment with a video message! The best way to send a greeting card.",
  sign_in_para: "Already have info saved?",
  sign_up_para: "Want to save this info for next time?",
  sign_in: "Sign in",
  sign_up: "Sign up",
  SIGN_UP: "SIGN UP",
  sign_up_header: "Join 50,000+ people for new bouquets + sales",
  form_required_text: "All fields marked with * are required.",
  delivery_window_para1: `Choose a delivery window for a contactless delivery!
  Please select the best time for your recipient to receive their gift.
  We'll text/call when we are on the way but we'll leave the box on the <span class='font-bold'>front step</span>
  (regardless of temperature!), with reception, or in the lobby if we can't get a hold of the recipient!`,
  delivery_window_para2: `On days when it’s colder than Mars, we wrap our bouquets in insulated
      packaging, which we like to call “space suits”, to protect the blooms from
      the cold. We also text/ call your recipient with an estimated time of
      arrival so that they know to bring the bouquet inside as soon as it's
      delivered!`,
  delivery_window_onfleet_region_para: `What <span class='font-bold'>cell phone number</span> should we send text updates to? It’s who we'll text when we’re on the way, so your <span class='font-bold'>recipient's</span> number is best!`,
  delivery_window_para4: `Add the recipients name and phone number below`,
  wedding_delivery_window_para3: `What <span class='font-bold'>cell phone number</span> should we send text updates to? We’ll send an ETA morning of delivery and another text when our driver is on the way. This is the <span class='font-bold'>only number we'll contact</span>, so the person who is receiving them is best!  `,
  wedding_delivery_window_para1: `Choose a delivery window! We’ll text on the way then call and knock/ring the doorbell when we arrive. If there’s no answer upon arrival, we’ll leave the box in a <span class='font-bold'>safe spot at the door</span> regardless of the temperature.`,
  card_msg_heading:
    "Choose any of the full-size greeting cards below (required)",
  card_msg_complementary: "Complimentary card options:",
  card_msg_exclusive: "Exclusive card options:",
  new: "New",
  greet_card_header: "Send a Greet",
  greet_card_upper_section: `Personalize your moment with a video message!<br/>
  The best way to send a greeting card.`,
  greet_card_bottom_section: `*We'll send instructions by email after your order is done.`,
  greet_card_btn_text: "How it works",
  greet_header: "Add a Video Message for $5",
  greet_card_sub_header: "Make it special with a Greet video message!",
  greet_card_modal_question_one: "1. Record your video and upload it (we'll send instructions!)",
  greet_card_modal_question_two: "2. They'll receive a QR code and URL in the greeting card to watch your video.",
  greet_card_modal_question_three:
    "3. Your gift arrives with your video greeting card.",
  greet_card_modal_answer_one: "Have family and friends join in.",
  greet_card_modal_answer_two: "We’ll send you instructions by email.",
  greet_card_modal_answer_three:
    "They open, scan the QR code or visit the URL, and watch.",
  address_types: ["Business", "House", "Apartment/Complex", "Hospital"],
  business: "Business",
  house: "House",
  apartment_complex: "Apartment/Complex",
  hospital: "Hospital",
  provinces: [
    "Alberta",
    "British Columbia",
    "Manitoba",
    "New Brunswick",
    "Nova Scotia",
    "Ontario",
    "Prince Edward Island",
    "Quebec",
    "Saskatchewan",
  ],
  form_lable_first_name: "First name",
  form_lable_last_name: "Last name",
  form_lable_email: "Email",
  form_lable_password: "Password",
  form_lable_address: "Address",
  form_lable_apartment: "Apartment, suite, etc",
  form_lable_city: "City",
  form_lable_province: "Province",
  form_lable_postal_code: "Postal code",
  form_lable_address_type: "Address type",
  form_lable_delivery_note: "Add your delivery notes",
  form_lable_relationship: "Relationship",
  form_lable_occasion: "",
  form_lable_contact_name: "Contact name",
  form_lable_contact_no: "Contact phone",
  form_valid_message: "Message is required",
  form_valid_first_name: "First name is required",
  form_valid_last_name: "Last name is required",
  form_valid_email: "Email address is required",
  form_valid_password: "Password is required",
  form_valid_address: "Address is required",
  form_valid_email: "Email is required",
  form_valid_emailVal: "Email address must be valid",
  form_valid_city: "City is required",
  form_valid_postal_code: "Postal Code is required",
  form_valid_province: "Province is required",
  form_valid_address_type: "Address Type is required",
  form_valid_contact_name: "Contact name is required",
  form_valid_contact_no: "Recipient cell phone number is required",
  form_valid_relationship: "Relationship is required",
  invalid_email: "Email address must be valid",
  invalid_postal_code: "Invalid postal code",
  invalid_phone_no: "Invalid phone number",
  country: "Country",
  province: "Province",
  city: "City",
  date: "Date",
  country_window_header:
    "Choose the country where you want your moment to be delivered.",
  province_window_header:
    "Tell us where you’re sending to see what gifts are available.",
  city_window_header:
    "Choose the city (or the closest one to) where you're sending to see available dates.",
  date_window_header: "Pick a delivery date to see what's available!",
  checkout_btn: "Checkout",
  add_to_basket: "Add to basket",
  select_city: "Select a city",
  select_delivery_date: "Select a date",
  select_variant: "Select a size",
  delivery_popup_btn: "Choose delivery city",
  cart_vase: "Vase",
  cart_special_gift: "Extra-special gifts",
  cart_delivery_window: "Delivery window",
  cart_addrs_info: "Address information",
  cart_conct_info: "Contact information",
  cart_edit: "Edit",
  cart_remove: "Remove",
  cart_tot_cost: "Total Cost",
  cart_continue_checkout: "Continue to checkout",
  cart_card: "Card",
  cart_page_header: "Your basket",
  places: "Places",
  place_sear_input_placeholder: "Search your location",
  place_no_avbl_data: "No data available",
  delivery_window_radio_header: `Want us to also <span class="font-bold">text the day before</span> to confirm delivery? *`,
  yes: "Yes",
  no: "No",
  collection_select: "Pick a bouquet collection",
  size_select: "Pick a bouquet size",
  delivery_dates: "Select delivery dates",
  delivery_dates_para:
    "We always deliver the freshest flowers. Pick your delivery dates for your subscription.",
  frequency: "Frequency",
  weeks_between_occurrences: "Weeks Between Deliveries",
  weeks: "Week(s)",
  week_frequency: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  week_frequency_err_msg: "Select the first delivery date",
  delivery_dates_bouquet: "Bouquet",
  "ongoing_delivery_date": "delivery date",
  message_text: "message",
  subscription_form_name: "Name",
  subscription_form_email: "Email address",
  learn_more: "Learn more",
  show_details: "Show Details",
  hide_details: "Hide Details",
  cart_add_another: "Add another",
  cart_order_now: "Order Now",
  cart_empty_msg: "Your cart is empty",
  returning_customers: "Returning customers",
  alert_message_incorrect_user_name: `Oopsie daisy! We don't have that email address registered.`,
  alert_message_incorrect_user_pass: "Oopsie daisy! Wrong password.",
  alert_message_pass_reset: "To access your account, please check your email and reset your password.",
  alert_message_signup_error: "So sorry, it appears there was an issue signing up. Please give us a call at (888) 618-1211",
  alert_message_signin_error: "So sorry, it appears there was an issue signing in. Please give us a call at (888) 618-1211",
  forgot_password: "Forgot password?",
  account_check: `Don't have an account? `,
  recovery_email_success_message: `Yay! We've sent an email to verify your account.`,
  recovery_email_not_found_message: "Email not found. Please sign up",
  submit_text: "Submit",
  return_text: "Return",
  continue_text: "Continue",
  password_recovery_text: "Password recovery",
  save_address_text: `We'll save your addresses and bouquet history!`,
  form_first_name_label: "First name",
  form_last_name_label: "Last name",
  form_cwn_code_label: "Enter code",
  existing_account_question: "Already have an account?",
  return_home: "Return to home",
  sign_in_up_popup_heading: "Thanks for signing up,",
  sign_in_up_popup_para:
    "You’re one step away… check your inbox for an email from us to confirm your account!",
  sign_in_up_popup_btn_text: "Ok",
  alert_message_existing_user_before: "User with email address",
  alert_message_existing_user_after: "already exists",
  unsatisfying_password: "Please ensure that the password contains a minimum of 8 characters with at least one capital letter, a number and a special character",
  hi_text: "Hi,",
  exclamation_mark: "!",
  view_account_text: "View account",
  my_orders_text: "My orders",
  my_addresses_text: "My addresses",
  recent_orders_text: "Recent orders",
  my_account_text: "My account",
  name_text: "Name",
  email_text: "Email",
  phone_text: "Mobile phone number",
  password_text: "Password",
  edit_btn_text: "Edit",
  back_text: "Back",
  order_text: "Order",
  order_summary_text: "Order summary",
  for: "For",
  extra_special_gift: "Extra-special gifts",
  subtotal: "Subtotal",
  discount: "Discount",
  tax: "Tax",
  total: "Total",
  edit_address_text: "Edit address",
  change_password_text: "Change password",
  new_password_text: "New password",
  new_password_lable: "New password (required)",
  confirm_password_lable: "Confirm password (required)",
  old_password_lable: "Old password (required)",
  new_valid_password: "New password is required",
  confirm_valid_password: "Confirm password is required",
  old_valid_password: "Old password is required",
  save_changes_text: "Save changes",
  delivery_window_enter_info: 'Enter Recipient info to view available delivery windows.',
  alert_message_password_not_match:
    "New password and Confirm password must match",
  alert_message_invalid_old_password: "Invalid old password",
  change_number_text: "Change mobile phone number",
  existing_number: "Existing number",
  invalid_password_alert_message: "Please provide valid Password",
  new_number: "New number",
  phone_number_label: "Phone number",
  email_label: "Email",
  delivery_address_label: "Delivery address",
  password_label: "Password",
  valid_phone: "Phone number required",
  invalid_phone: "Phone number must be valid",
  change_name_text: "Change name",
  existing_name_text: "Existing name",
  new_name: "New name",
  addresses_page_para: `Here's where to find the people <br> you care about.`,
  new_address_btn_text: "+ New address",
  primary_address: "Primary address",
  new_address_text: "New address",
  row_per_page_text: "Row per page:",
  of: "of",
  previous: "previous",
  next: "next",
  bouquet_name: "Bouquet name",
  recipient_name: "Recipient name",
  delivery_date: "Delivery date",
  wedding_date: "When is the big day?",
  wedding_date_name: "Date",
  order_num: "Order #",
  status: "Status",
  all: "All",
  alert_meassage_delivery_na: "Delivery not available at this postal code",
  address_label: "Address",
  apparement_label: "Apartment, suite, etc (optional)",
  city_label: "City",
  province_label: "Province",
  address_type_label: "Address type",
  postal_code_label: "Postal code",
  alias_label: "Alias (home, work)",
  valid_alias: "Alias is required",
  saved_recipients: "Saved Recipients",
  alias_requirment: "Alias must be less than 300 characters",
  delivery_note_label: "Delivery notes",
  save_primary_address: "Save as primary address",
  save_btn: "Save",
  cancel_btn: "Cancel",
  gift_card_blrb: `Want to send a super-flexible treat that they can use to order flowers as they choose? Our gift cards are a great (last-minute) gift: we'll email you an e-gift card they can redeem right away. Gift cards will be delivered to your email inbox within 24 hours.`,
  gift_card_form_heading: "Need a specific amount? Let us know!",
  form_gift_card_price_label: `Select gift card price`,
  form_gift_card_quantity_label: "Gift card quantity",
  valid_gift_card_quantity: "Number of gifts are required",
  form_gift_card_additional_notes_label: "Additional details (optional)",
  send_message_btn_text: "Send message",
  gift_card_success_alert_message: `Thanks for contacting us. We'll get back to you as soon as possible.`,
  gift_card_fail_alert_message: "Try again!!!",
  copyright: "&copy; 2025 Callia Inc",
  driver_form_page_heading: "Application: Delivery Driver",
  driver_form_page_para: `We're not accepting new applicants at this time. Check back again soon!`,
  switch_account_text: "Switch account",
  driver_form_instruction: "Your email will be recorded when you submit this form.",
  return_form_text: "Return to form",
  read_more: "Read More",
  rain: "Rain",
  clouds: "Clouds",
  drizzle: "Drizzel",
  snow: "Snow",
  thunder: "Thunder",
  clear: "Clear",
  perfect_weather: "Perfect weather for a 💐 delivery!",
  brr_weather: "Brrr! Make sure the 💐 can be brought inside ASAP.",
  scorcher_weather:
    "It's a scorcher! Make sure the 💐 can be brought inside ASAP.",
  weather_cold:
    "We've custom-designed a protective suit for your bouquet to wear on the chilliest of days! The perfect space-inspired technology for when it's colder than the equator of Mars! They're warm, luxurious, and 100% recyclable.",
  others_available_heading: 'You may also like',
  send_more_flowers_heading: 'Send more flowers',
  send_more_flowers_paragraph: "Perfect for Mother’s Day, Birthdays, Anniversaries, and more!",
  not_found_page_header: "Local delivery across Canada",
  not_found_page_sub_header: "The Page you're looking for has somehow disappeared. We'll fix it, sorry!",
  not_found_page_left_btn: "Go to Canadian homepage",
  not_found_page_right_btn: "Go to American homepage",
  more_photos: "Photos & Info",
  variant_sizes: ["Standard", "Deluxe", "Grand"],
  luxe_example_match: "Luxe collection<br>Example only: we'll make to match!",
  luxe_badge_text: "Luxe collection",
  example_match: "Example only: we'll make to match!",
  wedding_recipient_details: "How do we get in touch?",
  wedding_recipient_details_name: "Recipient",

  not_found_page_right_btn: "Go to American homepage",
  alert_message_delivery_rates_issue: "So sorry, we might not deliver here (yet!). Text us at",
  calli_contact_number: "(888) 618-1211",
  alert_message_delivery_rates_issue_check_text: `and we'll triple-check.`,
  alert_message_ongoing_subs_issue: "So sorry, we seem to be experiencing an issue with this order. Text us at <a class='text-white underline' href='tel:(888) 618-1211'>(888) 618-1211</a> and we can help you place it!",
  hear_about_us: "How did you hear about us?",
  hear_about_us_options: ['Instagram', 'Facebook Feed / Ad', 'Facebook Group', 'Regular Callia Customer', 'Wedding Wire', 'Callia Wedding Network', 'Google', 'Recommended by a friend/family', 'Wedding Show', 'TikTok', 'Pinterest', 'YouTube', 'Reddit', 'Other'],
  delivery_details: "Delivery Details",
  delivery_details_sub: "We'll deliver to your door 2-4 days in advance of your big day.",
  estimated_price: "Estimated price",
  after_quote_submit: "After you submit your quote, we'll email you within 12 hours with more details and next steps! Questions in the meantime? Check out our <a href=\"/en-ca/wedding-flowers/how-it-works\" class=\"text-primary cursor-pointer hover:underline\" target=\"_blank\">FAQ</a> page!",
  events_after_quote_submit: "After you submit your quote, we'll email you within 12 hours with more details and next steps! Questions in the meantime? Check out our <a href=\"/en-ca/events/how-it-works\" class=\"text-primary cursor-pointer hover:underline\" target=\"_blank\">FAQ</a> page!",
  card_message_placeholder: "",
  please_specify: "Please specify",
  referral_first_name_label: "Referral first name",
  referral_last_name_label: "Referral last name",
  referral_phone_number_label: "Referral phone number",
  referral_email_label: "Referral email",
  wedding_delivery_window: "Delivery window",
  wedding_delivery_window_name: "Delivery",
  wedding_post_submission_header: "You're all set!",
  wedding_post_submission_message: "YAY! Our wedding specialist will reach out within 12 hours - please check your spam/junk and add caitlin@calliaflowers.com as a contact. Any other questions in the meantime? Please send to caitlin@calliaflowers.com or check out our FAQ page. We can’t wait to work with you!",
  to_faq: "To FAQs",
  continue_to_gift: "Continue to pick a gift",
  review_feedback_label: "Share your feedback",
  delivery_window_text_lang_header: 'In what language should the delivery text be sent? *',
  english_text: 'English',
  french_text: 'French',
  discount_hint: `We'll apply the discount at checkout!`,
  donation_header: "Donations to Breast Cancer Canada of $10 or more will receive a tax receipt.",
  donations: 'Make a donation',
  no_products_available: 'So sorry! Our teams are picking the latest seasonal blooms! Check back soon to see our upcoming collection. Questions? Text us at 888-618-1211.',
  vase_treats_more_heading: "VASES & GIFTS",
  vase_heading: "Vases",
  addons_heading: "Gifts",
  cap_greets_heading: "GREETS",




  subs_freq_header: "1. How many bouquets do you want delivered?",
  subs_freq_sub_header: "Bouquets",
  subs_freq_subtotal: "Subtotal price: ",
  subs_freq_pick_dates_header: "2. Pick your delivery dates",

  ongoing_delivery_header: "Pick a delivery date",
  ongoing_freq_header: "Pick a frequency",
  ongoing_freq_sub_header: "How many weeks between deliveries?",
  ongoing_freq_subtotal: "Subtotal price: ",

  subs_addon: "",
  sub_addon_header: "Add more bouquets",
  sub_addon_learnmore: "Learn more",
  sub_addon_add_btn: "Add subscription",
  sub_addon_remove_btn: "Remove subscription",
  sub_addon_description: "Add 2 more months of bouquets for just",
  sub_addon_description_end_txt: "+ delivery each!",
  sub_main_header: "Upgrade to a subscription",
  sub_read_more_items: ["Make them smile 2 more times!",
    "Same size, our fave seasonal blooms.",
    "Delivery every 4 weeks from the first delivery date for 2 more months.",
    "The delivery fee is a standard $10 delivery rate."],
  sub_addon_read_more: "Read more",
  upgrade_now: "Upgrade now",
  sub_optional_date: "(Optional) Edit the dates if you’d like a special day instead (think birthday, anniversary or a holiday)!",
  password_reset_error: "So sorry, it appears there was an issue signing up. Please give us a call at (888) 618-1211",
  thanks_message: "Thanks for helping us bloom !",
  success_message1: "<h1 style='font-color:black; font-size:30px'>You're all set!</h1>  <br/><br/>",
  success_message2: ", thank you for helping us bloom!",
  contact_form_success_alert_message: `Thanks for contacting us. We'll get back to you as soon as possible.`,
  contact_form_fail_alert_message: "Please try again.",
  refunds: "Refunds",
  sitemap: "Sitemap",
  terms_and_conditions: "Terms & Conditions",
  privacy_policy: "Privacy Policy",
  pet_warning_link: "Sending to someone with pets? <a class='text-primary cursor-pointer hover:underline' href='#more-about-this'>Read this.</a>",
  pet_warning: "🐱 All flowers, if ingested, can make pets quite sick, but this bouquet in particular has a few riskier stems. We typically recommend keeping the bouquet out of reach of curious pets.",
  pet_heading: 'Pets',
  same_address_question: "Pressed bouquet shipping address same as delivery address",
  shipping_address_heading: "Pressed Bouquet Shipping Address",
  shipping_address_sub: "Shipped within 4 months of your wedding (we always aim for 2 months!).",
  sign_out: 'Sign out',
  account_text: 'Account',
  form_label_buzzer_code: 'Buzzer code',
  invalid_buzzer_code: 'Invalid buzzer code',
  card_max_chars_msg: "characters left",
  delivery_window_house: `Pick a window for contactless delivery! We’ll text/call when we’re on the way. We’ll leave the box on the step (no matter the weather) if we can’t reach them.`,
  delivery_window_business: `Choose a delivery window for a contactless delivery! Please select the best time for your recipient to receive their gift. We'll text/call when we are on the way but we'll leave the box on the with reception if we can't get a hold of the recipient!`,
  delivery_window_Apartment_Complex: `Choose a delivery window for a contactless delivery! Please select the best time for your recipient to receive their gift. We'll text/call when we are on the way but we'll leave the box in the lobby if we can't get a hold of the recipient!`,
  delivery_window_hospital: `Choose a delivery window for a contactless delivery! Please select the best time for your recipient to receive their gift. We'll deliver to the front desk (hospital rules)! We'll still call upon arrival so they know the blooms are in the building.`,
  delivery_window_curated: `Your moment will be delivered by the Canadian postal service. This means more moments in more places, yay! They will ring the doorbell and leave at the door. We are taking pre-orders until December 8th and your delivery will happen in the date range below:`,
  gift_card_address_label: 'Address for gift card delivery',
  gift_card_phone_number_label: 'Phone number',
  gift_card_phone_number_error: 'Phone number is required',
  gift_card_quantity_label: 'Gift card quantity',
  gift_card_quantity_error: 'Number of gifts is required',
  gift_card_first_name_label: 'First name',
  gift_card_last_name_label: 'Last name',
  gift_card_date_label: 'Date needed for',
  gift_card_submit_btn_text: 'Request Gift Cards',
  support_id: "Support #:  ",
  "Afternoon": "Afternoon",
  "Anytime": "Anytime",
  "Early Afternoon": "Early Afternoon",
  "Early Morning Rush": "Early Morning Rush",
  "Late Afternoon": "Late Afternoon",
  "Morning Rush": "Morning Rush",
  "1pm - 5pm": "1pm - 5pm",
  "9am - 5pm": "9am - 5pm",
  "9am - 3pm": "9am - 3pm",
  "9am - 10:30am": "9am - 10:30am",
  "3pm - 6pm": "3pm - 6pm",
  "9am - 12pm": "9am - 12pm",
  "9am - 1pm": "9am - 1pm",
  "1pm - 6pm": "1pm - 6pm",
  "9am - 7pm": "9am - 7pm",
  "10am - 5pm": "10am - 5pm",
  "10am - 6pm": "10am - 6pm",
  "11am - 5pm": "11am - 5pm",
  "10am - 12pm": "10am - 12pm",
  "3pm - 7pm": "3pm - 7pm",
  "1pm - 7pm": "1pm-7pm",
  "10am - 7pm": "10am - 7pm",
  "10am - 1pm": "10am - 1pm",
  "11am - 3pm": "11am - 3pm",
  "11am - 1pm": "11am - 1pm",
  "10am - 3pm": "10am - 3pm",
  "9am - 11am": "9am - 11am",
  "10am- 7pm": "10am -7pm",
  "9am - 6pm": "9am - 6pm",
  guest_verify_header: `Edit your message`,
  guest_verify_sub_heading: `Enter your last name & email address to adjust your order!💐`,
  btn_guest_verify: `View order details`,
  btn_guest_greet_update: 'Update',
  guest_greet_update_heading: 'Edit your greeting card message',
  guest_greet_order_summery_heading: 'Order summary',
  guest_greet_card_title_heading: 'Card',
  guest_greet_card_message_heading: 'Card message',
  guest_greet_updated_card_title_heading: 'Updated card',
  guest_greet_updated_card_message_heading: 'Updated card message',
  btn_edit_card_message_txt: 'Edit card message',
  countdown_timer_msg: `⏰ Hurry! Place your order within {time} to get delivery on {date} in {city}! ⏰`,
  starting_price: "Starting at",
  city_selector_heading: 'Delivery city',
  occasion_selector_heading:'Occasion',
  city_selector_placeholder: 'Enter your recipient’s city',
  delivery_date_selector_heading: 'Delivery date',
  delivery_date_selector_placeholder: 'Pick Your Delivery Date',
  no_delivery_here_text: `So sorry, we might not deliver here (yet!).`,
  text_us_text: `Text us at`,
  contact_callia_for_delivery_check: ` or click the chat below and we'll triple-check.`,
  classic_size: "Classic size",
  dd_mobile_text: "What a wonderful day to buy some flowers!",
  pickup_instruction: "Please enter a delivery city, date, then pick a size!",
  city_not_available_text: 'Entered city not available',
  get_started_btn_text: 'Get started',
  sub_delivery_date_selector_heading: '1st delivery date',
  delivering_in_cities_text: 'Delivering in 300+ cities across Canada.',
  start_typing_text: 'Start typing to select your city!',
  city_landing_main_header: "Picture-Perfect",
  province_landing_main_header: "Picture-Perfect",
  city_landing_sub_header: "Flower Delivery In {city}",
  province_landing_sub_header: "Flower Delivery In {province}",
  province_landing_delivery_para: "Get the best same day flower delivery in {province}, with bouquets that always match the picture. We deliver all week throughout {province}.",
  city_landing_delivery_para: "Get the best same day flower delivery in {city}, with bouquets that always match the picture. We deliver all week in {city} and in the surrounding area, and throughout {province}.",
  city_landing_delivery_main_image_alt_text: "Callia delivers flowers in {city} and surrounding areas.",
  province_landing_delivery_main_image_alt_text: "Callia delivers flowers in {province} and surrounding areas.",
  city_landing_delivery_view_more_button_text: "More Bouquets",
  city_landing_product_header: "Our Freshest {city} Flowers",
  province_landing_product_header: "Our Freshest {province} Flowers",
  province_deliver_in_text: "We also deliver in",
  city_landing_banner_para: "<strong>Made locally</strong> by our team and delivered from our hands to your door. <strong>No outsourcing</strong> to other florists or to Canada Post!",
  city_landing_occasion_banner_para: "Made locally by our team and delivered from our hands to their door in {city}. No outsourcing to other florists or to Canada Post!",
  city_landing_vp_header: "Best experience sending flowers",
  city_landing_occasion_vp_header: "Get the best experience sending {occasion} Flowers in {city}",
  city_landing_moment_header: "#ThisCalliaMoment",
  city_landing_moment_para: "Enter to win our monthly bouquet draw. Simply share your Callia bouquet on social media and tag #ThisCalliaMoment to enter.",
  city_landing_fresh_bq_header: "Fresh bouquets",
  city_landing_giftsets_header: "Gift sets",
  city_landing_dried_bq_header: "Dried bouquets",
  city_landing_subscription_header: "Subscription",
  city_landing_first_vp: {
    header: "Order easy",
    content: "Just a few clicks."
  },
  city_landing_scnd_vp: {
    header: "Delivered locally",
    content: "300+ places in Canada."
  },
  city_landing_fifth_vp: {
    header: "Picture perfect",
    content: "Just like the photo."
  },
  city_landing_sixth_vp: {
    header: "100% Callia Guarantee",
    content: "Our wrong? We'll fix it."
  },
  city_landing_review_header: "Loved by over 100,000 people",
  city_landing_review_header_mobile: "Loved by over<br> 100,000 people",
  city_landing_review_count: "Over 5,000 ",
  city_landing_review_constant: "reviews",
  city_landing_review_slides: [
    {
      msg: "Easy to order, beautiful\n" +
        "flowers, good price and stellar\n" +
        "delivery service. This company\n" +
        "is absolutely my new go-to for\n" +
        "quality floral delivery.\n",
      author: "Darla B"
    },
    {
      msg: "Great experience selecting a bouquet\n" +
        "of flowers online, website was easy to\n" +
        "use and straightforward, delivery was\n" +
        "smooth and bouquet was beautiful.\n" +
        "This process was so much easier than\n" +
        "shopping around for a florist in my\n" +
        "recipient s area and coordinating with their hours and delivery\n",
      author: "Nicole H"
    },
    {
      msg: "I have sent flowers to cherished\n" +
        "friends across Canada from\n" +
        "Callia with confidence in the\n" +
        "last year. Outstanding quality\n" +
        "and personalized service!\n" +
        "Amazing company!\n",
      author: "Kristine R"
    }
  ],
  city_landing_moment_slides: [
    {
      img: "https://cdn.buttercms.com/oyUEDKTny7PookI6nIDQ",
      link: "https://www.instagram.com/explore/tags/thiscalliamoment/",
      account: "@jennaraecakes"
    },
    {
      img: "https://cdn.buttercms.com/3SpdbvUTaOLT86Je7Hm8",
      link: "https://www.instagram.com/explore/tags/thiscalliamoment/",
      account: "@jenmariegreer"
    },
    {
      img: "https://cdn.buttercms.com/lNEpzVqdQOSJssaNYjjr",
      link: "https://www.instagram.com/explore/tags/thiscalliamoment/",
      account: "@janellewookey"
    },
    {
      img: "https://cdn.buttercms.com/QYwtrb5xS4uFJXYD8tQZ",
      link: "https://www.instagram.com/calliaflowers/",
      account: "@shinegoesplaces"
    },
    {
      img: "https://cdn.buttercms.com/WpMsqQPRN2G2w3aFXBTH",
      link: "https://www.instagram.com/calliaflowers/",
      account: "@micasa.lan"
    },
    {
      img: "https://cdn.buttercms.com/ZxxJ4pbShWGvLQOYGILg",
      link: "https://www.instagram.com/calliaflowers/",
      account: "@jennalynbrooks"
    }
  ],
  city_landing_bottom_header: "Fast & Reliable Flower Delivery in {city}",
  city_landing_dd_header: "As seen on CBC's <br><strong>Dragon’s Den</strong>",
  city_landing_bottom_para: "At Callia, we understand how much your {city} flower delivery means, especially for {occasion}." +
    " We share your passion for making each bouquet as special as the person receiving it. That's why we're committed to: <button class='text-primary underline'>{seeMore}</button>",
  city_landing_bottom_para_no_occasion: "At Callia, we understand how much your {city} flower delivery means." +
    " We share your passion for making each bouquet as special as the person receiving it. That's why we're committed to: <button class='text-primary underline'>{seeMore}</button>",
  city_landing_bottom_section_list: [
    { title: "Speedy Delivery", para: "Ensuring fast and reliable delivery every time" },
    { title: "Exceptional Value", para: "Providing great value without compromising on quality." },
    { title: "Freshness and Longevity", para: "Offering the freshest, longest-lasting flowers." },
    { title: "Seasonal Selections", para: "Featuring favorite flowers like lilies, roses, hydrangeas, and eucalyptus for that extra special touch." },
  ],
  city_landing_bottom_section_extra_para: "Our bouquets are more than just flowers; they are hand-tied masterpieces created by skilled artisans in our warehouses across Canada. " +
    "Unlike traditional flower delivery services, we don't rely on big shipping companies or outsourcing to other florists. " +
    "Instead, our dedicated team of drivers and couriers ensures each bouquet is delivered with care, directly from our nearest flower warehouse to your doorstep.\n",
  city_landing_bottom_section_faq_header: "Why Choose Callia? The Highest Rated Florist in Canada",
  city_landing_bottom_section_faq_list: [
    {
      title: "100% Callia Guarantee",
      para: "Every bouquet is backed by our unwavering commitment to quality. " +
        "Fresh blooms and quality gifts are delivered on time, every time. If we've missed the mark, let us know and we'll make it right!"
    },
    {
      title: "Same Day Delivery Available",
      para: "We offer prompt same day delivery, ensuring your bouquet arrives right when it's needed."
    },
    {
      title: "Customer Satisfaction",
      para: "As Canada's top-rated florist, your happiness is everything to us." +
        "Experience the difference with Callia's flower delivery service – because your special moments deserve nothing less."
    },
  ],
  city_landing_bottom_section_provincial_block: "City Landing Pages | Descriptions\n" +
    "When you need flower delivery in Manitoba, Callia has you covered. From Winnipeg to Brandon, Portage la Prairie to" +
    " Selkirk and Steinbach, our local same day and next day flower delivery schedule is tailored to meet your needs. With options ranging from standard to rush deliveries, we always ensure your bouquet arrives at the perfect moment. We also provide contactless delivery and real-time updates for peace of mind. Visit our FAQ page for more details on our same day delivery rates across Canada, in more than 300+ places.\n" +
    "Turn on screen reader support",
  see_more: "see more",
  hidden: "hide",
  holiday_main_heading: "Picture Perfect",
  holiday_main_sub_heading: "Local Flower Delivery",
  holiday_product_heading: "Our Freshest Holiday Arrangements",
  event_province_select: "Where is the event?",
  event_city_select: "Where is the event?",
  events_date: 'When is the event?',
  events_product_select: '',
  events_recipient_details: "How do we get in touch?",
  events_delivery_window: "Delivery window",
  events_post_submission_header: "You're all set!",
  events_post_submission_header_post_submission_message: "YAY! Our events specialist will reach out within 12 hours - please check your spam/junk and add caitlin@calliaflowers.com as a contact. Any other questions in the meantime? Please send to caitlin@calliaflowers.com or check out our FAQ page. We can’t wait to work with you!",
  number_of_people_text: 'Number of People',
  city_landing_occasion_meta_title: '{occasion} Flower Delivery in {city} | Callia',
  city_landing_occasion_meta_content: 'Fast {occasion} flower delivery in {city}. Shop picture-perfect floral arrangements and bouquets for {occasion2}. Hand-crafted by our local bouquet makers – not outsourced to other florists. Order now!',
  city_landing_meta_title: 'Online Flower Delivery in {city} | Callia',
  province_landing_meta_title: 'Online Flower Delivery in {province} | Callia',
  city_landing_meta_content: 'We deliver picture-perfect seasonal flower bouquets in {city}. Fast same-day delivery. Freshness guaranteed! Shop now.',
  delivery_window_courier_region_para: `What <span class='font-bold'>cell phone number</span> should we contact? We’ll call upon arrival! This is the <span class='font-bold'>only number we'll contact</span>, so the recipient's phone number is best!`,
  province_landing_meta_content: 'We deliver picture-perfect seasonal flower bouquets in {province}. Fast same-day delivery. Freshness guaranteed! Shop now.',
  wedding_landing_meta_title: "{city}Wedding Flowers Made Easy | Callia Wedding Florist",
  wedding_city_landing_meta_title: "Best Wedding Flowers in {city} | Callia Wedding Florist",
  wedding_landing_meta_content: "Wedding flowers {city}made affordable and easy with pricing all online. Florist fresh bouquets and arrangements for bride, bridesmaids, and wedding party.",
  sub6_freq_page_para: "How many weeks would you like between the deliveries? Our bouquets last 2+ weeks, so we recommend 3!",
  sub6_optional_date: "(Optional) Edit the dates!",
  sub3_optional_date: "(Optional) Edit the dates!",
  sub6_week_frequency: ["1", "2", "3", "4", "5", "6"],
  sub3_week_frequency: ["1", "2", "3", "4", "5"],
  sub6_frequency: "Select number of weeks between deliveries",
  sub6_card_message: "Card & messages",
  sub3_card_message: "Card & messages",
  sub6_complete_bouquet: "Add special gifts to your 1st delivery",
  sub3_complete_bouquet: "Add special gifts to your 1st delivery",
  special_date_complete_bouquet: "Add special gifts to your 1st delivery",
  occasion_page_faq_header: "Frequently asked questions",
  default_slider_heading_personal_page_text: 'The best gifts for your Valentine',
  default_slider_para_personal_page_text: 'Order now for Valentine’s Day!',
  sub_and_save: "Subscribe &  Save{amount}",
  sub_and_save_para: "Brighten their day every month!",
  make_it_a_sub: "Make it a subscription",
  sms_body: "Hi Callia team! I’d love to order flowers. Can you help?",
  email_subject: "Chat with a floral expert",
  email_body: "Hi Callia team! I’d love to order flowers. Can you help",
  shop_now: "Shop now",
  wedding_bulk_product:"Bulk Flowers: backed by our Callia Quality Guarantee.",
  wedding_bulk_product_name:"Bulk",
  events_bulk_product:"Bulk Flowers: backed by our Callia Quality Guarantee.",

  stems:'Stems',
  bunches:'bunches',
  wed_city_landing_page_main_slide: {
    image: "https://cdn.buttercms.com/7Aob21KTnGMZgSnbFi3Z",
    image_alt: "Bride and bridesmaids holding wedding bouquets",
    image_mobile: "https://cdn.buttercms.com/WYysYnwGR8muPm1y0Dps",
    mob_image_alt: "Bride and bridesmaids holding wedding bouquets",
    button_path: "$openWeddingDialog",
    button_text: "See pricing & styles",
    heading: "Wedding flowers made easy in",
    paragraph: "Easy ordering, in-season, budget-friendly.",
    micetype: "",
    signature: "",
  },
  wed_landing_page_main_slide: {
    image: "https://cdn.buttercms.com/7Aob21KTnGMZgSnbFi3Z",
    image_alt: "Bride and bridesmaids holding wedding bouquets",
    image_mobile: "https://cdn.buttercms.com/WYysYnwGR8muPm1y0Dps",
    mob_image_alt: "Bride and bridesmaids holding wedding bouquets",
    button_path: "$openWeddingDialog",
    button_text: "See pricing & styles",
    heading: "Wedding flowers made easy",
    paragraph: "Easy ordering, in-season, budget-friendly.",
    micetype: "",
    signature: "",
  },
  wed_city_landing_page_value_props: [
    {
      heading: "Fresh & in season wedding florals",
      image: "https://cdn.buttercms.com/RpB0Vb79TyZmK9rD7FLV",
      image_alt: "Bouquet of flowers",
    },
    {
      heading: "Budget-friendly pricing all online",
      image: "https://cdn.buttercms.com/Xi8xK5QMRgayzXIogGR0",
      image_alt: "Price tag with dollar symbol",
    },
    {
      heading: "Local delivery +300 places in Canada",
      image: "https://cdn.buttercms.com/aSwBTGM5RDKw63qmULrU",
      image_alt: "Car moving fast",
    },
    {
      heading: "Florals that arrive as pictured online",
      image: "https://cdn.buttercms.com/RPwt9W6UTSWTa88owWeG",
      image_alt: "Cellphone with hearts on screen",
    },
  ],
  wed_city_landing_page_section_divider_content:'Stress-free wedding floral arrangements at unbeatable value',
  wed_city_landing_page_section_divider_subcontent:'Wedding flowers in {{city name}} have never been easier and more affordable, with wedding flower pricing and availability all online. We can help with wedding floral quotes in {{city name}} and across {{province name}} for your ceremony and reception online in minutes.',
  wed_city_landing_page_gallery_images1: [
    {
      src: "https://cdn.buttercms.com/Aq3THsOStOFoS13WOYpg",
      image_alt: "Bride",
    },
    {
      src: "https://cdn.buttercms.com/S0pzizLTP2rA0V1MfjtP",
      image_alt: "Bride and groom",
    },
    {
      src: "https://cdn.buttercms.com/h7gr0fITTASwzQQdKw6p",
      image_alt: "Bride and bridesmaid",
    },
    {
      src: "https://cdn.buttercms.com/APUaYsxSbGgjJ5Pn03tf",
      image_alt: "Bride and groom holding hands",
    },
    {
      src: "https://cdn.buttercms.com/tILCJbqToqZc0ULf9n62",
      image_alt: "Bridesmaids smiling",
    },
    {
      src: "https://cdn.buttercms.com/odD3x8ULQVach1fsl4AJ",
      image_alt: "Bride with dog and flowers",
    },
    {
      src: "https://cdn.buttercms.com/5DOoIMnVT7KXdeaoWqhr",
      image_alt: "Bride and groom hugging in flowers",
    },
    {
      src: "https://cdn.buttercms.com/CLihYcJfQCOaWtyzRWgN",
      image_alt: "Bride with bridesmaids",
    },
  ],
  wed_city_landing_page_how_service_works_heading:'How our wedding flower service works',
  wed_city_landing_page_content_block1: [
    {
      heading: "Select a date & location",
      image: "https://cdn.buttercms.com/v6BtSUXDTpykOTAYW2Td",
      image_alt: "Calendar page with heart",
      content:
        "<p style=\"text-align: center;\"><span>Tell us when you're getting married and where to deliver. Browse the seasonal styles that we've designed for that date! We deliver across Canada in 300+ places!</span></p>",
    },
    {
      heading: "Add numbers",
      image: "https://cdn.buttercms.com/Et2e9jhqT5OuaKMVbBl1",
      image_alt: "Flower bouquet",
      content:
        "<p><span>Select what florals you think you'll need. Make a 20% deposit or pay in full based on your wedding date.</span></p>",
    },
    {
      heading: "Finalize plan with us",
      image: "https://cdn.buttercms.com/Wl8UdNxR6CY3MfJDFa5J",
      image_alt: "A planner with a pen",
      content:
        "<p><span>Pick from our curated bouquet styles, confirm quantities and logistics (when styles are released, about 4-8 months out). Relax and enjoy your big day!</span></p>",
    },
  ],
  wed_city_landing_page_our_wedding_bouquets_heading:'Our Wedding Bouquets',
  wed_city_landing_page_season_para:`See what's in season!`,
  wed_city_landing_page_see_pricing_btn_txt:'See pricing & options',
  wed_city_landing_page_marketing_showcase_header:'As seen on:',
  get_started_now_btn_txt:'Get started now',
  wed_city_landing_page_hsection_header:`{{city name}}'s Most-Loved Wedding Flowers`,
  wed_city_landing_page_loved_by_txt:'Loved by over 4000 weddings',
  get_quote_txt:'Get quote',
  more_callia_wed_moments_txt:'Looking to see more Callia wedding moments?',
  wedding_flower_gallary_txt:'Wedding flower gallery',
  more_faq_txt:'More FAQs',
  wed_city_landing_page_content_block2: [
    {
      image: "https://cdn.buttercms.com/OU0AEGYTSOwS1getmUuC",
      image_alt: "Bridal party holding bouquets",
      image_position: "left",
      heading: "In-style & in-season arrangements",
      content:
        "<p><span>We choose super-fresh flowers and greens to make gorgeous, seasonal bouquets. We can't get you tulips in January or peonies in November, but we'll get you beautiful florals at a fantastic value. If our flowers were any fresher, they'd still be on the farm!</span></p>",
      button_path: "",
      button_text: "",
      button_style: "",
      is_video: false,
      video_url: "",
    },
    {
      image: "https://cdn.buttercms.com/dPcBZMBRxmbfOFTyyioA",
      image_alt: "Head table with flowers and decorations",
      image_position: "right",
      heading: "Super simple & budget-friendly",
      content:
        "<p><span>By working with seasonal flowers in pre-set styles, we’re about 75% less expensive than average wedding flowers (most couples only spend about $700 with us)! We have bouquets, boutonnières, corsages, bulk florals & greenery, DIY floral decor, and centrepieces. No consultation or customization fees!</span></p>",
      button_path: "",
      button_text: "",
      button_style: "",
      is_video: false,
      video_url: "",
    },
    {
      image: "https://cdn.buttercms.com/YndsraYcS6OBHidXHFaN",
      image_alt: "Bridal party walking down street",
      image_position: "left",
      heading: "Hand-crafted & hand-tied bouquets",
      content:
        "<p><span>We carefully arrange our bouquets in a wildflower, garden-inspired look! We design each bouquet style to be fresh, seasonal and beautifully balanced, so we don’t offer any customization, which is how we can bring you the best value and keep the process easy! We switch up the floral styles every 4-6 weeks!</span></p>",
      button_path: "",
      button_text: "",
      button_style: "",
      is_video: false,
      video_url: "",
    },
  ],
  wed_city_landing_page_gallery_images2: [
    {
      src: "https://cdn.buttercms.com/SrtBFM4XTYqC9T5Yr417",
      image_alt: "Flower arrangement on table",
    },
    {
      src: "https://cdn.buttercms.com/N8aS2tq0QDWHT2ZJtnrW",
      image_alt: "Babies breath",
    },
    {
      src: "https://cdn.buttercms.com/YFeGbpGLTDCPrl4TUI4i",
      image_alt: "Bride and groom under arch",
    },
    {
      src: "https://cdn.buttercms.com/NIhyaXwROSnTP007t0aA",
      image_alt: "Multicolored flower bouquet",
    },
    {
      src: "https://cdn.buttercms.com/dSaggELFTf2gcefy77r4",
      image_alt: "Flower arrangement on table",
    },
    {
      src: "https://cdn.buttercms.com/fdrMpRrpTtePeH4cdeGn",
      image_alt: "Bride and groom kissing down aisle",
    },
    {
      src: "https://cdn.buttercms.com/LOO6mscpQ2KJ2kcXPXAm",
      image_alt: "Table flower display",
    },
    {
      src: "https://cdn.buttercms.com/rHnAfaYIRtSxCnyCxN2B",
      image_alt: "Bride with bouquets of flowers",
    },
  ],
  wed_city_landing_page_reviews: [
    {
      image: "https://cdn.buttercms.com/m0yI4w2nSDyQvYYKlPhz",
      image_alt: "A bride and bridesmaids holding flowers",
      content:
        "“Loved my experience with Callia! Straight forward, easy, and low stress. Delivery was smooth and efficient. Bouquets and boutonnieres were stunning and lasted a long time. Can't say enough good things about getting our wedding flowers through Callia. Price was fantastic and made everything to do with our florals so easy!”",
      name: "— Real Callia Bride Kirsten, August 2023",
    },
    {
      image: "https://cdn.buttercms.com/ZyWPVJeRNOCNbZ3tkUAy",
      image_alt: "Bride and groom holding hands",
      content:
        "“SO glad I found Callia for my wedding! Flowers arrived in perfect condition and lasted weeks afterwards! Beautiful and exactly what I was expecting based on the pictures online. Appreciated the open, clear communication - from the quote, to the order, to the delivery - I was involved In the whole process and knew I was in good hands. 12/10 recommend!”",
      name: "— Real Callia Bride Francesca, July 2023",
    },
    {
      image: "https://cdn.buttercms.com/Q39HVJbQxQJwtf4ZE7ww",
      image_alt: "A bride and bridesmaids holding flowers",
      content:
        "“Flowers were absolutely gorgeous and exactly as described! So many compliments on them. Service was phenomenal, right down to the wonderfully friendly delivery driver. Couldn’t have asked for a better floral experience!”",
      name: "— Real Callia Bride Jade, August 2023",
    },
    {
      image: "https://cdn.buttercms.com/bmlazyCMRyuUQQPICdrj",
      image_alt: "Bride and groom",
      content:
        "“Amazing! Loved my bouquet and boutonniere. Communication was great and instructions were clear. Very impressed with the size of the bouquet for the price point. It was a really hot day and the flowers were out of water for hours and held up nicely until I could get them in water again.”",
      name: "— Real Callia Bride Natalie, June 2023",
    },
  ],
  wed_city_landing_page_showcase: [
    {
      src: "https://cdn.buttercms.com/6Ym9OOYZQOC9EN8oNT8e",
      alt: "Dragons' Den",
    },
    { src: "https://cdn.buttercms.com/ABUL20FCSk4gCVWpQ3D0", alt: "Yahoo" },
    {
      src: "https://cdn.buttercms.com/WhLLwK37TVGN4yjvPfHe",
      alt: "The Globe and Mail",
    },
    {
      src: "https://cdn.buttercms.com/YEfy9XStQByjkIYAmCAC",
      alt: "Curiocity",
    },
    {
      src: "https://cdn.buttercms.com/WB1H9ShTf2ypSM1ZfTlk",
      alt: "CTV News",
    },
    {
      src: "https://cdn.buttercms.com/AxWRfT8ZQde00QhRVqjL",
      alt: "Global News",
    },
    {
      src: "https://cdn.buttercms.com/95tmwZfJQjKLQA8MswJO",
      alt: "FASHION",
    },
    { src: "https://cdn.buttercms.com/gAYZnWEESlSTnoJYgC57", alt: "CBC" },
  ],
  faqs_text:'FAQs',
  wed_landing_page_hsection_header:'Most-Loved Wedding Flowers',
  wed_city_landing_page_faqs: [
    {
      question:"How do I know if Callia Flowers is right for my {{city name}} wedding?",
      answer:"<p><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">Callia Flowers is great for anyone who wants in-season, affordable, and gorgeous fresh wedding flowers in </span><strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">{{city name}}</span></strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">. Callia fills the gap between full DIY floral options and traditional wedding florists through a streamlined, online ordering process that makes purchasing wedding flowers simple and stress-free. Callia is the best fit for weddings that are not looking to spend thousands and thousands on wedding flowers or looking for a super-specific floral scheme. Callia helps with wedding arrangements in </span><strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">{{city name}}</span></strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\"> and</span><strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\"> </span></strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">over 300 places locally in Canada and is the most reviewed wedding florist on Wedding Wire.</span></p>",
      video_url: "",
      text_size: "",
    },
    {
      question: "What makes Callia Flowers different from other wedding florists in {{city name}}?",
      answer:"<p><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">Callia Flowers is the modern way of ordering wedding flowers in </span><strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">{{city name}}</span></strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">. The process, transparency, and affordability behind how we help with wedding flowers differently, gives us the confidence to say Callia is the best new approach to wedding flowers. Callia&rsquo;s process is streamlined all online, saving couples time spent in consultations that translates to direct floral cost savings. Floral pricing is always fully transparent online with no price gatekeeping, no hidden fees, and no exclusivity agreements. Callia&rsquo;s wedding flowers, bouquets, and decor are always super fresh which is one of the reasons why delivery in </span><strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">{{city name}}</span></strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\"> takes place two to four days the wedding date to ensure flowers can bloom for the big day and Callia can help with any fixes in the super rare event something is not 100% perfect. Callia&rsquo;s wedding flowers are more affordable and fresh compared to average Canadian wedding flowers thanks to the streamlined process and standardized floral designs.</span></p>",
      video_url: "",
      text_size: "",
    },
    {
      question:"How does Callia Flowers ensure the freshness of wedding florals upon delivery in {{city name}}?",
      answer:"<p><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">Callia Flowers only uses in-season, fresh ingredients for every wedding in </span><strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">{{city name}}</span></strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">. Floral designs change frequently throughout the year based on what ingredients are in-season to ensure couples receive the highest quality florals throughout the entire year. All wedding florals and decor are processed locally after arriving from the flower farms, then hand-tied and delivered by our own team (no UPS/FedEx!) to your delivery address in </span><strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">{{city name}}</span></strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">. We have our 100% Callia Guarantee and <a href='/en-ca/wedding-flowers/how-it-works' class='text-primary hover:underline'>24-Wedding Policy</a> that allows us to help with any fixes and make your flowers perfect before your wedding date in the event something is not 100% correct when you receive your wedding flower delivery. We maintain rigorous floral standards which is why we&rsquo;re loved by thousands of happy couples throughout all of Canada and in </span><strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">{{city name}}.</span></strong></p>",
      video_url: "",
      text_size: "",
    },
    {
      question:"How many flowers do you need for your {{city name}} wedding?",
      answer:"<p><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">Traditionally for the wedding party, the bride and bridesmaids will all have fresh floral bouquets while the groomsmen will have pin-on boutonnieres worn on their jacket lapels. Special guests will have florals too. Mothers and grandmothers will typically wear wrist corsages, while pin-on boutonnieres are worn by fathers and grandfathers. Wedding officiants often wear a boutonniere or corsage based on what best fits their attire. For decor, florals vary based on your vision and budget. Traditionally, most will have a centrepiece for their guest or sweetheart table and some kind of florals like bud vases or traditional centrepieces featured at each guest table and at the head table of the reception.</span></p>",
      video_url: "",
      text_size: "",
    },
    {
      question:"How do I get wedding flower pricing from Callia Flowers in {{city name}}?",
      answer:"<p><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">Callia Flowers wedding pricing for </span><strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">{{city name}}</span></strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\"> is always transparent online in the Wedding quote tool. Once you enter your wedding location and date, you&rsquo;ll be able to see the floral designs, decor, and pricing for the time of your wedding. After you submit your quote, you&rsquo;ll receive an email of your quote to help in your wedding planning journey.</span></p>",
      video_url: "",
      text_size: "",
    },
    {
      question:"Does Callia Flowers offer floral arrangements for other wedding-related events like bridal showers or engagement parties in {{city name}}?",
      answer:"<p><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">Callia Flowers offers floral arrangements and decor for all events in </span><strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">{{city name}} </span></strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">including bridal showers, engagement parties, rehearsal dinners, and other wedding-related events. Pricing and availability are transparently displayed online in the <a href='/en-ca/events' class='text-primary hover:underline'>Events quote tool</a> where you can order floral arrangements for your pre-wedding events easily, online in minutes.</span></p>",
      video_url: "",
      text_size: "",
    },
  ],
  wed_city_landing_page_faq_items: [
    {
      question: "How do I know if Callia Flowers is right for my wedding?",
      answer:"<p><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">Callia Flowers is great for anyone who wants in-season, affordable, and gorgeous fresh wedding flowers. Callia fills the gap between full DIY floral options and traditional wedding florists through a streamlined, online ordering process that makes purchasing wedding flowers simple and stress-free. Callia is the best fit for weddings that are not looking to spend thousands and thousands on wedding flowers or looking for a super-specific floral scheme. Callia helps with wedding arrangements in</span><strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\"> </span></strong><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">over 300 places locally in Canada and is the most reviewed wedding florist on Wedding Wire.</span></p>",
      video_url: "",
      text_size: "",
    },
    {
      question:"What makes Callia Flowers different from other wedding florists?",
      answer:'<p style="margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 11pt; font-family: \'Open Sans\', sans-serif; color: rgb(0, 0, 0);">Callia Flowers is the modern way of ordering wedding flowers. The process, transparency, and affordability behind how we help with wedding flowers differently, gives us the confidence to say Callia is the best new approach to wedding flowers. Callia&rsquo;s process is streamlined all online, saving couples time spent in consultations that translates to direct floral cost savings. Floral pricing is always fully transparent online with no price gatekeeping, no hidden fees, and no exclusivity agreements. Callia&rsquo;s wedding flowers, bouquets, and decor are always super fresh which is one of the reasons why delivery takes place two to four days before the wedding date to ensure flowers can bloom for the big day and Callia can help with any fixes in the super rare event something is not 100% perfect. Callia&rsquo;s wedding flowers are more affordable and fresh compared to average Canadian wedding flowers thanks to the streamlined process and standardized floral designs.</span></p>',
      video_url: "",
      text_size: "",
    },
    {
      question:"How does Callia Flowers ensure the freshness of wedding florals upon delivery?",
      answer:"<p style=\"margin-top: 0pt; margin-bottom: 0pt;\"><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">Callia Flowers only uses in-season, fresh ingredients for every wedding. Floral designs change frequently throughout the year based on what ingredients are in-season to ensure couples receive the highest quality florals throughout the entire year. All wedding florals and decor are processed locally after arriving from the flower farms, then hand-tied and delivered by our own team (no UPS/FedEx!) to your delivery address. We have our 100% Callia Guarantee and <a href='/en-ca/wedding-flowers/how-it-works' class='text-primary hover:underline'>24-Wedding Policy</a> that allows us to help with any fixes and make your flowers perfect before your wedding date in the event something is not 100% correct when you receive your wedding flower delivery. We maintain rigorous floral standards which is why we&rsquo;re loved by thousands of happy couples throughout all of Canada.</span></p>",
      video_url: "",
      text_size: "",
    },
    {
      question: "How many flowers do you need for your wedding?",
      answer:'<p style="margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 11pt; font-family: \'Open Sans\', sans-serif; color: rgb(0, 0, 0);">Traditionally for the wedding party, the bride and bridesmaids will all have fresh floral bouquets while the groomsmen will have pin-on boutonnieres worn on their jacket lapels. Special guests will have florals too. Mothers and grandmothers will typically wear wrist corsages, while pin-on boutonnieres are worn by fathers and grandfathers. Wedding officiants often wear a boutonniere or corsage based on what best fits their attire. For decor, florals vary based on your vision and budget. Traditionally, most will have a centrepiece for their guest or sweetheart table and some kind of florals like bud vases or traditional centrepieces featured at each guest table and at the head table of the reception.</span></p>',
      video_url: "",
      text_size: "",
    },
    {
      question: "How do I get wedding flower pricing from Callia Flowers?",
      answer:'<p style="margin-top: 0pt; margin-bottom: 0pt;"><span style="font-size: 11pt; font-family: \'Open Sans\', sans-serif; color: rgb(0, 0, 0);">Callia Flowers wedding pricing is always transparent online in the Wedding quote tool. Once you enter your wedding location and date, you&rsquo;ll be able to see the floral designs, decor, and pricing for the time of your wedding. After you submit your quote, you&rsquo;ll receive an email of your quote to help in your wedding planning journey.</span></p>',
      video_url: "",
      text_size: "",
    },
    {
      question:"Does Callia Flowers offer floral arrangements for other wedding-related events like bridal showers or engagement parties?",
      answer:"<p style=\"margin-top: 0pt; margin-bottom: 0pt;\"><span style=\"font-size: 11pt; font-family: 'Open Sans', sans-serif; color: rgb(0, 0, 0);\">Callia Flowers offers floral arrangements and decor for all events including bridal showers, engagement parties, rehearsal dinners, and other wedding-related events. Pricing and availability are transparently displayed online in the <a href='/en-ca/events' class='text-primary hover:underline'>Events quote tool</a> where you can order floral arrangements for your pre-wedding events easily, online in minutes.</span></p>",
      video_url: "",
      text_size: "",
    },
  ],
  event_province_select_name: "Province",
  event_city_select_name:"City",
  events_product_select_name: "Florals",
  events_date_name: "Date",
  events_recipient_details_name: "Recipient",
  events_delivery_window_name: "Delivery",
  events_bulk_product_name: "Bulk",
  tip_label: "Tip",
  tip_error: "Enter a tip",
  password_reset_header:'Password Reset Confirmation',
  password_reset_para:'Password Reset Done',
  occasion_heading:'Occasion',
  select_size_hint_msg: 'Please Select a Size Below',
  message_generate_btn_text:'✨ Magically generate message ✨',
  greeting_card_messge_heading:'Greeting Card Message',
  greeting_card_messge_para:'Want help putting your feelings into words? Try this new magical way to write a personalized message!',
  card_message_top_para: " Or type your message below.",
  form_label_signature: "Your Signature",
  form_label_signature_para: " This will be added to your message - you don't need to sign twice, just put your sign-off here!",
  form_valid_signature:'Your Signature is required',
  form_valid_occasion: "Occasion is required",
  business_text:'Business',
  business_name_label:'Business name',
  business_name_error:'Business name is required',
  image_upload_text: 'Accepts most photo formats!',
  new_image: "New Image",
  reset_image: "Reset",
  save_image: "Crop and Save",
  edit_image: "Edit Image",
  loved_by_canadians_mday: "Loved by 50k+ Canadian Moms",
};
